import RouterPage from './Pages/RouterPage';
import React, { useEffect, useState } from 'react';
import './assets/css/admin.css';
import LoadingScreen from './Components/Loading/LoadingScreen';

function App() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoader(false);
    }, 15000);
    return () => clearTimeout(timeout);
  }, []);

  const handleLoaderEnd = () => {
    setShowLoader(false);
  };

  return (
      <div className="App">
        {showLoader && <LoadingScreen onEnded={handleLoaderEnd} />}
        {!showLoader && <RouterPage />}
      </div>
    );
}

export default App;
